import { render, staticRenderFns } from "./contextsubmenu.vue?vue&type=template&id=172b6b98&scoped=true&"
import script from "./contextsubmenu.vue?vue&type=script&lang=js&"
export * from "./contextsubmenu.vue?vue&type=script&lang=js&"
import style0 from "./contextsubmenu.vue?vue&type=style&index=0&id=172b6b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b6b98",
  null
  
)

export default component.exports